enum SiteType {
  Retail = 'Retail',
  Showroom = 'Showroom',
  Distribution = 'Distribution',
  Corporate = 'Corporate',
  Headquarters = 'Headquarters',
  Lab = 'Lab',
  DataCenter = 'DataCenter',
  Office = 'Office',
  Gwan = 'Gwan',
}

export default SiteType;
